import { Button } from "@wags/ui/button.tsx";
import { usePostHog } from "posthog-js/react";
import type { ComponentProps } from "react";

export function ShelterCta({
    applicationUrl,
    isApplicationPage = false,
    organizationName,
    onContact,
    className,
    size,
}: {
    applicationUrl: string | null;

    isApplicationPage?: boolean;
    organizationName: string;

    onContact?: () => void;
} & Pick<ComponentProps<typeof Button>, "className" | "size">) {
    const posthog = usePostHog();
    if (applicationUrl) {
        const label = isApplicationPage
            ? "Start application"
            : "Visit their site";
        return (
            <Button
                type="button"
                aria-label={label}
                className={className}
                emphasis="cta"
                size={size}
                asChild
            >
                <a
                    href={applicationUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => {
                        posthog.capture("external_link_clicked", {
                            type: isApplicationPage ? "application" : "website",
                            organizationName,
                        });
                    }}
                >
                    {label}
                </a>
            </Button>
        );
    }
    if (!onContact) return null;
    return (
        <Button
            type="button"
            aria-label="Contact shelter"
            className={className}
            emphasis="cta"
            size={size}
            onClick={() => {
                onContact();
            }}
        >
            Contact shelter
        </Button>
    );
}
